import {
  floor, ceil,
} from 'lodash/fp';

export const getHours = duration => (`0${floor(duration / 3600) || 0}`).slice(-2);

export const getMinutes = duration => (`0${ceil((duration / 60) % 60) || 0}`).slice(-2);

export const getSeconds = (duration, minutes) => (`0${(duration - minutes * 60) || 0}`).slice(-2);
